<template>
  <v-card flat class="is-clickable pa-3" @click="readMore()">
    <v-row no-gutters align="center">
      <v-col class="col-12 col-sm-auto">
        <v-icon class="mr-4" color="primary" large>fas fa-pager</v-icon>
      </v-col>
      <v-col class="flex-grow-1">
        <div>
          <v-chip
            color="primary"
            class="white--text ma-0 text-uppercase caption font-weight-bold"
            small
            >{{
              $t(`newsTutorial.statusLabels.${newsTutorialItem.type}`)
            }}</v-chip
          >
          <span class="ml-2 text-no-wrap font-weight-medium">{{
            newsTutorialItem.date | date(dateTimeFormat)
          }}</span>
        </div>
        <div class="title font-weight-bold my-1">
          {{ newsTutorialItem.title }}
        </div>
        <div class="font-weight-medium">{{ getDescriptionText }}</div>
      </v-col>
      <v-col class="col-12 col-sm-auto">
        <v-btn
          class="ma-0 caption font-weight-bold"
          color="primary"
          outlined
          rounded
        >
          {{ $t("newsTutorial.item.cta-btn") }}
        </v-btn>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
export default {
  props: {
    newsTutorialItem: {
      required: true
    }
  },
  data() {
    return {
      dateTimeFormat: `DD/MM/YYYY - ${this.$i18n.t("hour")} HH.mm`
    };
  },
  created() {},
  computed: {
    getDescriptionText() {
      const MAX_DESC_TEXT_LENGTH = 99;
      let description = this.newsTutorialItem.description;
      if (description) {
        if (description.length > MAX_DESC_TEXT_LENGTH)
          return (
            this.newsTutorialItem.description.slice(0, MAX_DESC_TEXT_LENGTH) +
            "..."
          );
        else return description;
      } else return "";
    }
  },
  methods: {
    readMore() {
      this.$router.push({
        name: "newsTutorialDetails",
        params: { id: this.newsTutorialItem.id }
      });
    }
  }
};
</script>

<style scoped>
.newsTutorialItem__description {
  width: 400px;
}
</style>
